/* Lumine - strip the leftover "(n)" count from cloned sort rows.
   The drawer sort list is cloned from a filter row, which carries a bare
   text node with the product count next to .facet-checkbox__text-label.
   CSS hides it, but it still lands in the accessible name, so remove it. */
(function () {
  function clean() {
    var rows = document.querySelectorAll('input[name="sort_by"][type="radio"]');
    for (var i = 0; i < rows.length; i++) {
      var li = rows[i].closest('li');
      if (!li || li.dataset.lumineClean === 'yes') continue;
      var wrap = li.querySelector('.facet-checkbox__text');
      if (!wrap) continue;
      li.dataset.lumineClean = 'yes';
      var kids = Array.prototype.slice.call(wrap.childNodes);
      for (var j = 0; j < kids.length; j++) {
        var n = kids[j];
        var isLabel =
          n.nodeType === 1 &&
          n.classList &&
          n.classList.contains('facet-checkbox__text-label');
        if (!isLabel) wrap.removeChild(n);
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      clean();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
